import {Resource} from "../../api/resource";
import {BasicEntity, BasicProperty} from "../../basic-entity-back/annotations";
import {PropertyType} from "../../basic-entity-back/property-type/property-type";
import {ManagerCachingStrategy} from "../../basic-entity-back/basic-entity-interface/mapping-external";

@BasicEntity({
    name: "Sistema",
    endpoint: "sistemas",
    isPaginated: false,
    modelNameProperty: "sistema",
    managerCaching: ManagerCachingStrategy.Lazy
})
export class Sistema extends Resource {

    @BasicProperty({
        name: "ID",
        isId: true,
        type: PropertyType.Integer()
    })
    private _id: number;

    @BasicProperty({
        name: "Sistema",
        type: PropertyType.String()
    })
    private _sistema: string;

    get id(): number {
        return this._id;
    }

    set id(value: number) {
        this._id = value;
    }

    get sistema(): string {
        return this._sistema;
    }

    set sistema(value: string) {
        this._sistema = value;
    }
}
